import { FieldType } from '@ngx-formly/core';

export class FieldBaseComponent extends FieldType {
  public get valid() {
    return (this.formControl.dirty || this.formControl.touched) && !this.showError;
  }

  public get invalid() {
    return this.showError;
  }

  public get errorId() {
    return `${this.id}-error-id`;
  }

  public get errorDescriptionId() {
    return `${this.id}-error-description-id`;
  }
}
